<template>
    <v-dialog v-model="open" full-width="true">
      <v-btn slot="activator" color="primary" block small> Expand </v-btn>
      <v-card>
        <v-card-title> <v-btn color="error" block @click="open = !open">Close</v-btn> </v-card-title> 
        <v-img class="u-d-image" contain="true" :src="image"/>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'image-dialog',
  props: ['image'],
  data() {
    return {
      open: false
    };
  }
}
</script>
